<template>    
    <header ref="header">
        <div class="logo" ref="logo">
            <router-link to="/">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="240px" height="27px" viewBox="0 0 240 27" style="enable-background:new 0 0 240 27;" xml:space="preserve">
                    <path shape-rendering="geometricPrecision" d="M91.7,13.1l5.6-12.6h-7.5l-4.2,11.2l0.2-11.2h-7.1v26.1h7.1l-0.2-12.1l4.7,12.1H98L91.7,13.1z M64.4,26.6V20 c0-1,0-2.3-0.1-3.6c-0.1-1.3-0.2-3-0.3-4.8c0.2,0.8,0.5,1.6,0.8,2.6c0.3,0.9,0.6,1.8,1,2.9l3.6,9.6h6.8V0.5h-6.8v5.8 c0,1.1,0.1,2.5,0.2,4.1c0.1,1.6,0.3,3.6,0.6,5.8L69.5,14c-0.3-0.9-0.5-1.7-0.8-2.5c-0.2-0.7-0.4-1.3-0.6-1.8l-3.6-9.2h-6.8v26.1 H64.4z M43.7,17.7l0.7-4.1l0.5-3.2c0-0.1,0-0.2,0.1-0.5c0-0.3,0.1-0.7,0.2-1.4c0-0.3,0.1-0.7,0.1-0.9c0-0.3,0.1-0.5,0.1-0.8l0.1,2.5 c0.1,0.5,0.1,0.9,0.1,1.2s0.1,0.6,0.1,0.8c0.2,1.7,0.3,2.7,0.3,3c0,0.3,0.1,0.4,0.1,0.4l0.4,3.1H43.7z M49.8,0.5h-8.6l-6.2,26.1h7.3 l0.6-3.3h4.7l0.5,3.3h7.3L49.8,0.5z M32.5,20.3h-5.3V0.5h-7.1v26.1h12.4V20.3z M7.1,6.1c0.2,0,0.3,0,0.4,0s0.2,0,0.3,0 c1.6,0,2.5,0.7,2.5,2.3c0,0.7-0.2,1.2-0.7,1.6c-0.5,0.4-1.1,0.6-2,0.6H7.1V6.1z M7.1,15.9h0.5c0.9,0,1.6,0.2,2.2,0.6 c0.5,0.4,0.8,1,0.8,1.8c0,0.8-0.3,1.4-0.8,1.8c-0.5,0.5-1.2,0.7-2.2,0.7c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0V15.9z M9.8,26.6 c2.4,0,4.3-0.7,5.7-2c1.4-1.3,2.2-3.2,2.2-5.4c0-1.7-0.4-3.2-1.3-4.1c-0.8-0.9-2.3-1.5-4.1-1.8c3.3-0.3,4.9-2,4.9-5.3 c0-2.2-0.7-4-2.3-5.4c-1.4-1.3-3.8-2-6.9-2H0v26.2H9.8z M239.9,26.6v-6.2h-6v-4h5.4v-5.9h-5.4V6.6h6V0.5h-13.1v26.1H239.9z M224.7,0.5H217l-1.6,8.6c-0.2,1.3-0.5,2.7-0.6,4c-0.2,1.3-0.3,2.9-0.4,4.4c-0.3-3.5-0.7-6.8-1.1-9.6l-1.3-7.5h-7.4l5.9,26.1h7.2 L224.7,0.5z M202.2,0.5h-7.1v26.1h7.1V0.5z M188.8,6.7h4V0.5h-14.9v6.2h3.9v19.9h7.1V6.7z M167,17.7l0.7-4.1l0.5-3.2 c0-0.1,0-0.2,0.1-0.5c0-0.3,0.1-0.7,0.2-1.4c0-0.3,0.1-0.7,0.1-0.9c0-0.3,0.1-0.5,0.1-0.8l0.1,2.5c0.1,0.5,0.1,0.9,0.1,1.2 c0,0.3,0.1,0.6,0.1,0.8c0.2,1.7,0.3,2.7,0.3,3c0,0.3,0.1,0.4,0.1,0.4l0.4,3.1H167z M173.1,0.5h-8.6l-6.2,26.1h7.3l0.6-3.3h4.7 l0.5,3.3h7.3L173.1,0.5z M156.5,26.6v-6.2h-6v-4h5.4v-5.9h-5.4V6.6h6V0.5h-13.1v26.1H156.5z M129.9,6.3h0.2c2,0,3.1,1,3.1,3 c0,0.9-0.3,1.7-0.8,2.4c-0.5,0.6-1.2,0.9-2,0.9h-0.5V6.3H129.9z M136.1,15.8c2.7-1.2,4-3.4,4-6.6c0-3-1-5.2-3-6.9 c-1.5-1.2-4-1.8-7.2-1.8h-7.2v26.1h7.1v-9.1v-1.7c0.1,0.4,0.2,0.7,0.3,0.9c0.1,0.3,0.1,0.5,0.2,0.6l3.5,9.3h7.7L136.1,15.8z M116.7,20.3c-0.7,0-1.3-0.1-1.9-0.4c-0.5-0.3-1-0.7-1.4-1.3c-0.4-0.6-0.7-1.3-0.9-2.2c-0.2-0.8-0.3-1.7-0.3-2.9 c0-2.2,0.4-3.9,1.2-5.1c0.8-1.2,1.9-1.8,3.4-1.8c1.1,0,2.2,0.5,3.3,1.5V0.6c-1-0.4-2.3-0.6-3.4-0.6c-3.5,0-6.3,1.2-8.4,3.7 c-2,2.5-3.2,5.8-3.2,9.9c0,4.4,1.1,7.8,3.4,10.2c1.9,2.2,4.5,3.2,7.4,3.2c1.2,0,2.7-0.3,4.2-0.9l0.4-7.6 C119.1,19.6,117.9,20.3,116.7,20.3z" />
                </svg>
            </router-link>
        </div>
        <nav>
            <ul>
                <li><router-link to="/"><span class="label">Work</span></router-link></li>
                <li><router-link to="/about"><span class="label">About</span></router-link></li>
            </ul>
        </nav>
    </header>    
</template>

<script>
    import { store } from '../store.js'
    import { gsap } from 'gsap';
    
    export default {
        name: 'PageHeader',
        
        // Properties returned from data() become reactive state
        // and will be exposed on `this`.
        data() {
            return {
                store
            }
        },
        
        props: {},
        
        // Methods are functions that mutate state and trigger updates.
        // They can be bound as event listeners in templates.
        methods: {},
        
        watch: {
            $route (to){
                if( window.innerWidth >= 768 ){
                   if(to.path == '/about') {
                        gsap.to(this.$refs.header, {
                            ease: 'expo',
                            left: '0%',
                            duration: 1,
                            delay: (store.introAnimationDone) ? 0 : 7.5
                        });
                    } else {
                        gsap.to(this.$refs.header, {
                            ease: 'expo',
                            left: '70%',
                            duration: 1,
                            delay: (store.introAnimationDone) ? 0 : 7.5
                        });
                    }
                }                
            }
        },
        
        computed: {},
        
        // Lifecycle hooks are called at different stages
        // of a component's lifecycle.
        // This function will be called when the component is mounted.
        mounted() {
			
			if( window.innerWidth >= 768 ){
				gsap.set(this.$refs.header, {
					left: '35%'
				});
			}
			
        }
        
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    header {
        position: fixed;
        top: 20px;
        width: 100%;
        z-index: 10;
        /*background-color: antiquewhite*/
    }
    @media (min-width: 768px) {
        header {
            top: 100px;
            width: 30%;
        }
    }
    header .logo {
        display: flex;
        justify-content: center;
        padding: 0 20px;
    }
    header .logo a {
        display: flex;
    }
    header .logo svg {
        position: relative;
        width: 100%;
        height: auto;
        display: block;
        max-width: 240px
    }
    header nav {    
        margin-top: 10px;
        display: flex;
        justify-content: center;
        padding: 0 20px;
    }
    @media (min-width: 768px) {
        header nav {
            opacity: 0;
            pointer-events: none;
            user-select: none;
            transition: opacity 250ms ease;
        }
    }
    @media (min-width: 768px) {
        header:hover nav {
            opacity: 1;
            pointer-events: auto;
            transition: opacity 250ms ease;
        }
    }
    header nav ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        column-gap: 10px;
    }
    header nav ul li {
        display: flex;
    }
    header nav ul li a {
        position: relative;
        color: #414042;
        text-transform: uppercase;
        text-decoration: none;
    }
    header nav ul li a:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        height: 1px;
        background-color: #414042;
        opacity: 0;
        transition: opacity 250ms ease;
    }
    header nav ul li a.current:after {
        opacity: 1;
        transition: opacity 250ms ease;
    }
    
    .fadein-enter-active,
    .fadein-leave-active {
        transition: opacity 250ms ease;
    }

    .fadein-enter-from,
    .fadein-leave-to {
        opacity: 0;
    }
</style>